import { axiosInstance } from "../../../../AppUtils/Utils/axios";
import { filterApiData } from "../../../../AppUtils/Utils/appFunctions";
import {
  getApiProps,
  searchProps,
} from "../../../../AppUtils/Utils/globalTypes";

const prodCatURL = "/api/v1/admin/product-app/product-category";

//get product category
export const getProductCategory = (data: getApiProps) => {
  const { rowsPerPage, page } = data;
  return axiosInstance.get(
    `${prodCatURL}?offset=${rowsPerPage * page}&limit=${rowsPerPage}${
      data?.filterData ? filterApiData(data?.filterData) : ""
    }`
  );
};

//get product category by id
export const getProductCategoryById = (id: number) => {
  return axiosInstance.get(`${prodCatURL}/${id}`);
};

//search
export const searchProductCategory = ({ rowsPerPage, search }: searchProps) => {
  return `${prodCatURL}?offset=0&limit=${rowsPerPage}&search=${search}`;
};

//create
export const createProductCategory = (body: string | FormData) => {
  return axiosInstance.post(`${prodCatURL}`, body);
};

//update
export const updateProductCategory = (body: string | FormData, id: number) => {
  return axiosInstance.patch(`${prodCatURL}/${id}`, body);
};
